import actions from "@/store/modules/tutorial/actions";
import mutations from "@/store/modules/tutorial/mutations";
import state from "@/store/modules/tutorial/state";

export default {
    actions,
    mutations,
    state
}